// removed by extract-text-webpack-plugin
module.exports = {"paypalLogo":"_3NnMt"};


//////////////////
// WEBPACK FOOTER
// ./components/icons/PayPalIcon/PayPalIcon.scss
// module id = 277
// module chunks = 0 1